// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_header__\\+KzXD {
  padding: 5rem 9.5rem;
  box-sizing: border-box;
}
@media only screen and (max-width: 62.5em) {
  .Header_header__\\+KzXD {
    padding: 5rem 5rem;
  }
}
.Header_header__nav__SGdc3 {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
@media only screen and (max-width: 62.5em) {
  .Header_header__nav__SGdc3 {
    justify-content: space-between;
  }
}
.Header_header__nav__btn__YIhaR {
  display: flex;
  gap: 2.3rem;
}
@media only screen and (max-width: 62.5em) {
  .Header_header__nav__btn__YIhaR {
    display: none;
  }
}
.Header_header__nav_icon__EyHJS {
  display: none;
  cursor: pointer;
}
@media only screen and (max-width: 62.5em) {
  .Header_header__nav_icon__EyHJS {
    display: block;
    font-size: 5rem;
  }
  .Header_header__nav_icon__EyHJS:hover {
    color: var(--color-primary);
  }
}

.Header_logo__exjkz {
  width: 18rem;
  height: 100%;
}

.Header_nav__item__aI6oK {
  display: flex;
  list-style: none;
}
.Header_nav__item__list__Pxw8w {
  text-decoration: none;
  color: var(--color-dark);
  cursor: pointer;
}
.Header_nav__item__list__Pxw8w:hover, .Header_nav__item__list__Pxw8w:active {
  font-weight: 700;
  color: var(--color-primary);
}
.Header_nav__item__list__Pxw8w:not(:last-child) {
  margin-right: 2.5rem;
}
.Header_nav__item__link__ziJPm:link, .Header_nav__item__link__ziJPm:visited {
  text-decoration: none;
  color: var(--color-dark);
  cursor: pointer;
}
.Header_nav__item__link__ziJPm:link:hover, .Header_nav__item__link__ziJPm:link:active, .Header_nav__item__link__ziJPm:visited:hover, .Header_nav__item__link__ziJPm:visited:active {
  font-weight: 700;
  color: var(--color-primary);
}
@media only screen and (max-width: 62.5em) {
  .Header_nav__item__aI6oK {
    display: none;
  }
}

.Header_btn__icon__DTU\\+U {
  height: 2.2rem;
  margin-right: 1rem;
}

.Header_slide__uNopk {
  margin-top: 10rem;
  display: grid;
  grid-template-columns: repeat(2, max-content);
  justify-content: center;
  box-sizing: border-box;
}
@media only screen and (max-width: 62.5em) {
  .Header_slide__uNopk {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3rem;
    margin-top: 4rem;
  }
}
.Header_slide__text__W0eyd {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 65rem;
  padding-right: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Header_slide__text__W0eyd {
    text-align: center;
  }
}
.Header_slide__text_btn__VKJ0U {
  display: flex;
  gap: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Header_slide__text_btn__VKJ0U {
    justify-content: center;
  }
}
@media only screen and (max-width: 37.5em) {
  .Header_slide__text_btn__VKJ0U {
    flex-direction: column;
    align-items: center;
  }
}
.Header_slide__img__RVwmC {
  width: 58rem;
}
@media only screen and (max-width: 62.5em) {
  .Header_slide__img__RVwmC {
    width: 40rem;
  }
}

.Header_menu__5ACxl {
  width: 100vw;
  height: 100vh;
  background-color: var(--color-light);
  position: fixed;
  padding: 5rem 10rem;
  overflow-y: scroll;
  z-index: 100;
}
@media only screen and (max-width: 37.5em) {
  .Header_menu__5ACxl {
    padding: 5rem 5rem;
  }
}
.Header_menu__logo__zeBtA {
  width: 18rem;
}
.Header_menu__top__wQs-k {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}
.Header_menu__icon__EVWCp {
  font-size: 5rem;
  color: var(--color-primary);
  cursor: pointer;
}
.Header_menu__nav__gLaK\\+ {
  height: 50vh;
  display: flex;
  flex-direction: column;
  font-size: var(--default-font-subtitle);
  text-align: center;
  justify-content: space-evenly;
  margin-bottom: 2rem;
}
.Header_menu__nav__item__BtO8M {
  list-style: none;
}
.Header_menu__nav__link__y\\+JQf {
  cursor: pointer;
  text-decoration: none;
  color: var(--color-dark);
}
.Header_menu__nav__link__y\\+JQf:hover, .Header_menu__nav__link__y\\+JQf:focus {
  font-weight: 700;
  color: var(--color-primary);
}
.Header_menu__nav__btn__w3G6K {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Header_main__4dfNU {
  position: relative;
}

.Header_modal__4KfLZ {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.Header_modal__4KfLZ img {
  height: 27rem;
  border-radius: 3rem;
  margin: 2rem 0;
}

.Header_businesses__SPQKe {
  margin-top: 4rem;
  text-align: center;
}
@media only screen and (max-width: 62.5em) {
  .Header_businesses__title__lLmVq {
    font-size: var(--default-font-h3);
  }
}
.Header_businesses__list__rADG2 {
  display: flex;
  justify-content: space-between;
  margin-right: 2rem;
  color: var(--color-grey);
}
.Header_businesses__img__3VM7r {
  height: 5rem;
  width: 10rem;
  object-fit: cover;
  border-radius: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/LandingPage/Header.module.scss"],"names":[],"mappings":"AAEA;EACC,oBAAA;EACA,sBAAA;AADD;AAGC;EAJD;IAKE,kBAAA;EAAA;AACF;AAEC;EACC,aAAA;EACA,6BAAA;EACA,mBAAA;AAAF;AAEE;EALD;IAME,8BAAA;EACD;AACF;AAAE;EACC,aAAA;EACA,WAAA;AAEH;AADG;EAHD;IAIE,aAAA;EAIF;AACF;AAFE;EACC,aAAA;EACA,eAAA;AAIH;AAHG;EAHD;IAIE,cAAA;IACA,eAAA;EAMF;EALE;IACC,2BAAA;EAOH;AACF;;AAFA;EACC,YAAA;EACA,YAAA;AAKD;;AAFC;EACC,aAAA;EACA,gBAAA;AAKF;AAJE;EACC,qBAAA;EACA,wBAAA;EACA,eAAA;AAMH;AALG;EAEC,gBAAA;EACA,2BAAA;AAMJ;AAJG;EACC,oBAAA;AAMJ;AAHE;EAEC,qBAAA;EACA,wBAAA;EACA,eAAA;AAIH;AAHG;EAEC,gBAAA;EACA,2BAAA;AAIJ;AAAE;EA5BD;IA6BE,aAAA;EAGD;AACF;;AAIC;EACC,cAAA;EACA,kBAAA;AADF;;AAMA;EACC,iBAAA;EACA,aAAA;EACA,6CAAA;EACA,uBAAA;EACA,sBAAA;AAHD;AAKC;EAPD;IAQE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,SAAA;IACA,gBAAA;EAFA;AACF;AAIC;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAFF;AAIE;EAPD;IAQE,kBAAA;EADD;AACF;AAGE;EACC,aAAA;EACA,SAAA;AADH;AAEG;EAHD;IAIE,uBAAA;EACF;AACF;AAAG;EAND;IAOE,sBAAA;IACA,mBAAA;EAGF;AACF;AACC;EACC,YAAA;AACF;AACE;EAHD;IAIE,YAAA;EAED;AACF;;AAEA;EACC,YAAA;EACA,aAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AACD;AACC;EATD;IAUE,kBAAA;EAEA;AACF;AAAC;EACC,YAAA;AAEF;AACC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AACF;AAEC;EACC,eAAA;EACA,2BAAA;EACA,eAAA;AAAF;AAGC;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uCAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;AADF;AAGE;EACC,gBAAA;AADH;AAIE;EACC,eAAA;EACA,qBAAA;EACA,wBAAA;AAFH;AAIG;EAEC,gBAAA;EACA,2BAAA;AAHJ;AAOE;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AALH;;AAUA;EACC,kBAAA;AAPD;;AAUA;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;AAPD;AASC;EACC,aAAA;EACA,mBAAA;EACA,cAAA;AAPF;;AAUA;EACC,gBAAA;EACA,kBAAA;AAPD;AAWE;EAFD;IAGE,iCAAA;EARD;AACF;AAWC;EACC,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,wBAAA;AATF;AAYC;EACC,YAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAVF","sourcesContent":["@import '../variables/breakpoints';\n\n.header {\n\tpadding: 5rem 9.5rem;\n\tbox-sizing: border-box;\n\n\t@media only screen and (max-width: $bp-large) {\n\t\tpadding: 5rem 5rem;\n\t}\n\n\t&__nav {\n\t\tdisplay: flex;\n\t\tjustify-content: space-evenly;\n\t\talign-items: center;\n\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\tjustify-content: space-between;\n\t\t}\n\t\t&__btn {\n\t\t\tdisplay: flex;\n\t\t\tgap: 2.3rem;\n\t\t\t@media only screen and (max-width: $bp-large) {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t\t&_icon {\n\t\t\tdisplay: none;\n\t\t\tcursor: pointer;\n\t\t\t@media only screen and (max-width: $bp-large) {\n\t\t\t\tdisplay: block;\n\t\t\t\tfont-size: 5rem;\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor: var(--color-primary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.logo {\n\twidth: 18rem;\n\theight: 100%;\n}\n.nav {\n\t&__item {\n\t\tdisplay: flex;\n\t\tlist-style: none;\n\t\t&__list {\n\t\t\ttext-decoration: none;\n\t\t\tcolor: var(--color-dark);\n\t\t\tcursor: pointer;\n\t\t\t&:hover,\n\t\t\t&:active {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t}\n\t\t\t&:not(:last-child) {\n\t\t\t\tmargin-right: 2.5rem;\n\t\t\t}\n\t\t}\n\t\t&__link:link,\n\t\t&__link:visited {\n\t\t\ttext-decoration: none;\n\t\t\tcolor: var(--color-dark);\n\t\t\tcursor: pointer;\n\t\t\t&:hover,\n\t\t\t&:active {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t}\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n// button style\n\n.btn {\n\t&__icon {\n\t\theight: 2.2rem;\n\t\tmargin-right: 1rem;\n\t}\n}\n\n//Slide section\n.slide {\n\tmargin-top: 10rem;\n\tdisplay: grid;\n\tgrid-template-columns: repeat(2, max-content);\n\tjustify-content: center;\n\tbox-sizing: border-box;\n\n\t@media only screen and (max-width: $bp-large) {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tgap: 3rem;\n\t\tmargin-top: 4rem;\n\t}\n\n\t&__text {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\tmax-width: 65rem;\n\t\tpadding-right: 2rem;\n\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\ttext-align: center;\n\t\t}\n\n\t\t&_btn {\n\t\t\tdisplay: flex;\n\t\t\tgap: 2rem;\n\t\t\t@media only screen and (max-width: $bp-large) {\n\t\t\t\tjustify-content: center;\n\t\t\t}\n\t\t\t@media only screen and (max-width: $bp-small) {\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: center;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__img {\n\t\twidth: 58rem;\n\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\twidth: 40rem;\n\t\t}\n\t}\n}\n\n.menu {\n\twidth: 100vw;\n\theight: 100vh;\n\tbackground-color: var(--color-light);\n\tposition: fixed;\n\tpadding: 5rem 10rem;\n\toverflow-y: scroll;\n\tz-index: 100;\n\n\t@media only screen and (max-width: $bp-small) {\n\t\tpadding: 5rem 5rem;\n\t}\n\n\t&__logo {\n\t\twidth: 18rem;\n\t}\n\n\t&__top {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tmargin-bottom: 2rem;\n\t}\n\n\t&__icon {\n\t\tfont-size: 5rem;\n\t\tcolor: var(--color-primary);\n\t\tcursor: pointer;\n\t}\n\n\t&__nav {\n\t\theight: 50vh;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tfont-size: var(--default-font-subtitle);\n\t\ttext-align: center;\n\t\tjustify-content: space-evenly;\n\t\tmargin-bottom: 2rem;\n\n\t\t&__item {\n\t\t\tlist-style: none;\n\t\t}\n\n\t\t&__link {\n\t\t\tcursor: pointer;\n\t\t\ttext-decoration: none;\n\t\t\tcolor: var(--color-dark);\n\n\t\t\t&:hover,\n\t\t\t&:focus {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t}\n\t\t}\n\n\t\t&__btn {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t}\n\t}\n}\n\n.main {\n\tposition: relative;\n}\n\n.modal {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\n\timg {\n\t\theight: 27rem;\n\t\tborder-radius: 3rem;\n\t\tmargin: 2rem 0;\n\t}\n}\n.businesses {\n\tmargin-top: 4rem;\t\n\ttext-align: center;\n\t\n\t&__title {\n\t\t\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\tfont-size: var(--default-font-h3);\t\t\t\n\t\t}\n\t}\n\n\t&__list{\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin-right: 2rem;\n\t\tcolor: var(--color-grey);\t\n\t}\n\n\t&__img {\n\t\theight: 5rem;\n\t\twidth: 10rem; \n\t\tobject-fit: cover;\n\t\tborder-radius: 1rem;\n\t\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header_header__+KzXD`,
	"header__nav": `Header_header__nav__SGdc3`,
	"header__nav__btn": `Header_header__nav__btn__YIhaR`,
	"header__nav_icon": `Header_header__nav_icon__EyHJS`,
	"logo": `Header_logo__exjkz`,
	"nav__item": `Header_nav__item__aI6oK`,
	"nav__item__list": `Header_nav__item__list__Pxw8w`,
	"nav__item__link": `Header_nav__item__link__ziJPm`,
	"btn__icon": `Header_btn__icon__DTU+U`,
	"slide": `Header_slide__uNopk`,
	"slide__text": `Header_slide__text__W0eyd`,
	"slide__text_btn": `Header_slide__text_btn__VKJ0U`,
	"slide__img": `Header_slide__img__RVwmC`,
	"menu": `Header_menu__5ACxl`,
	"menu__logo": `Header_menu__logo__zeBtA`,
	"menu__top": `Header_menu__top__wQs-k`,
	"menu__icon": `Header_menu__icon__EVWCp`,
	"menu__nav": `Header_menu__nav__gLaK+`,
	"menu__nav__item": `Header_menu__nav__item__BtO8M`,
	"menu__nav__link": `Header_menu__nav__link__y+JQf`,
	"menu__nav__btn": `Header_menu__nav__btn__w3G6K`,
	"main": `Header_main__4dfNU`,
	"modal": `Header_modal__4KfLZ`,
	"businesses": `Header_businesses__SPQKe`,
	"businesses__title": `Header_businesses__title__lLmVq`,
	"businesses__list": `Header_businesses__list__rADG2`,
	"businesses__img": `Header_businesses__img__3VM7r`
};
export default ___CSS_LOADER_EXPORT___;
